import React, { ReactNode } from 'react';
import { baseXUnit, color, spacing } from '../../styles/theme';
import H from '../elements/H';
import ButtonText from '../elements/ButtonText';
import Icon from '../common/Icon';

interface SummaryHeadingCount {
  text: ReactNode;
  renderCount: () => ReactNode;
}
const SummaryHeading: React.FunctionComponent<
  SummaryHeadingCount & React.HTMLProps<HTMLDivElement>
> = ({ text, renderCount, ...rest }) => {
  return (
    <div className="summary-heading" {...rest}>
      <div className="count">
        <H styling="h4" tag="div" data color="purpleLight">
          {renderCount()}
        </H>
      </div>
      <div className="text">
        <ButtonText variant="primary">
          <strong className="icon-text">{text}</strong>
        </ButtonText>
      </div>
      <div className="icon">
        <Icon name="nav-arrow-right" size={2} color="purple-light" />
      </div>
      {/*language=CSS*/}
      <style jsx>{`
        .summary-heading {
          display: flex;
        }
        .text,
        .icon {
          display: flex;
          align-items: center;
        }
        .count {
          margin-right: ${spacing.one};
          border-radius: ${baseXUnit(0.5)};
          background-color: ${color.lightBackground};
          padding: ${spacing.fourth} 0;
          text-align: center;
          /* Reserve space for two numbers also during loading */
          min-width: ${baseXUnit(5)};
          min-height: ${baseXUnit(3.5)};
        }
        .text {
          margin-right: ${spacing.half};
          /* Better alignment with the count */
          margin-top: 2px;
        }
      `}</style>
    </div>
  );
};

export default SummaryHeading;
